import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export default VisibilityOutlinedIcon;
